// import { FilterDropdown } from '@refinedev/antd';
// import { Input, Radio, FormInstance } from 'antd';
// import { FilterDropdownProps } from 'antd/lib/table/interface';
// import React from 'react'
// import { FieldDB } from '../../../src/interfaces/schemaDB';


// interface Cw8ListFilterProps{
//     props : FilterDropdownProps
//     , field: FieldDB
// }

// interface Cw8ListFilterFieldProps{
//     typeField : string
// }

// const Cw8ListFilterField = ({typeField}:Cw8ListFilterFieldProps) =>{

//     switch(typeField){
//         case 'checkbox':
//             return  <Radio.Group>
//                         <Radio value="1">Si</Radio>
//                         <Radio value="0">No</Radio>
//                     </Radio.Group>
//             default :
//             return <Input />
//     }
// }


// const Cw8ListFilter = ({props, field} : Cw8ListFilterProps) => {
//     return(
//         <FilterDropdown {...props}>
//             <Cw8ListFilterField typeField={field.type}></Cw8ListFilterField>
//         </FilterDropdown>
//     ) 

// }

// export default Cw8ListFilter


import React, { useEffect, useState } from 'react'
import { Form, FormProps, Input, Select, DatePicker, Button, Space, FormInstance } from "antd";
import Cw8Field from './Cw8Field';
import { FieldDB } from '../../../src/interfaces/schemaDB';
import { FormMode } from 'interfaces/interfaces';


interface Cw8ListFilterProps{
    formProps: FormProps
    fieldList: FieldDB[]
    // formProps : FormProps
    // filterList?: CrudFilters | undefined
    resourceName : string
    form : FormInstance
}

// const Cw8ListFilter: React.FC<{ formProps: FormProps }> = ({ formProps }) => {
const Cw8ListFilter  = ({ formProps, fieldList, resourceName, form } : Cw8ListFilterProps) => {


    const [fields, setFields] = useState(fieldList)

    // const { form } = useForm({})

    useEffect(() => {
        // setFieldList( getCreateField(table?.length==1?table[0]:null) )

        const fieldsTmp : FieldDB[] = []
        fieldList.forEach( field =>{
            if(field.type != "file" && field.filterSearch){

                if(field.type == "txt" || field.type == "multipleLookupValues" || field.type == "multipleRecordLinks" || field.type == "checkbox" || field.type == "date" || field.type == "singleSelect"){
                // if(field.type == "txt"  || field.type == "checkbox" || field.type == "date" || field.type == "singleSelect"){

                }else{
                    field.type = "txt"
                }
                field.isKey = 0
                field.edit = 1
                fieldsTmp.push( field )
            }
        })
        setFields( fieldsTmp )
    }, [fieldList])    


    return (
        <Form layout="vertical" {...formProps} className="cw8Searcher">
            {
                fields.map( (field, idx) =>(
                    <Cw8Field
                        key = {idx}
                        field = {{...field, ...{required:0}}}
                        formMode = {FormMode.search}
                        resourceName = {resourceName}
                        form = {form}
                    ></Cw8Field>
                ))
            }
            <div style={{ textAlign: 'right' }}>
                <Space direction={"horizontal"} >

                            <Form.Item >
                                <Button htmlType="reset" >
                                    Reset
                                </Button>
                            </Form.Item>            

                            <Form.Item>
                                <Button htmlType="submit" type="primary">
                                    Buscar
                                </Button>
                            </Form.Item>
                </Space>
            </div>
        </Form>
    )
}

export default Cw8ListFilter

